export function checkIfASCII(val: string): boolean {
  return /^[\x00-\x7F]*$/.test(val);
}

export function normalizeString(name: string): string {
  if (name == null) return null;
  name = name.toUpperCase().trim();
  if (name.trim() !== "." && name.substring(name.length - 1, name.length) === ".") {
    name = name.substring(0, name.length - 1).trim();
  }
  return name;
}


export function checkIfValidHostName(host: string): boolean {
  const DOMAIN_PATTERN = new RegExp(/^([A-Za-z0-9\-]+\.)*[A-Za-z0-9\-]+$/);
  return DOMAIN_PATTERN.test(host);
}

/**
 * Returns true if the hostname's last label matches the given TLD name.
 */
export function isHostnameUnderTld(hostname: string, tldName: string): boolean {
  if (!hostname || !tldName) {
    return false;
  }
  return hostname.split('.').at(-1)?.toLowerCase() === tldName.toLowerCase();
}

  export function checkIfValueIsHex(value: string): boolean {
  const HEX_PATTERN = new RegExp(/^[0-9A-Fa-f]+$/);
  return HEX_PATTERN.test(value);
}

export function checkIfGiveCharIsNumberOrLetter(char: string): boolean {
  if (char == null || char.trim() === "") {
    return false;
  }
  const letterOrNumber = new RegExp(/^[0-9a-zA-Z]+$/);
  return letterOrNumber.test(char);

}

export function checkIfGivenStringIsNumber(char: string):boolean{
  const numberRegex = new RegExp(/^\d+$/);
  return numberRegex.test(char);
}

/**
 * Converts a flatpickr date string (MM/DD/YYYY) to ISO format (YYYY-MM-DD).
 * Never passes the value through `new Date()` to avoid timezone shifts.
 * Returns '' for empty or malformed input.
 */
export function flatpickrToIso(value: string | null | undefined): string {
  if (!value) return '';
  const parts = value.split('/');
  if (parts.length !== 3) return '';
  const [mm, dd, yyyy] = parts;
  return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
}

/**
 * Converts an ISO date string (YYYY-MM-DD) to the MM/DD/YYYY format expected by flatpickr.
 * Returns '' for empty or malformed input.
 */
export function isoToFlatpickr(value: string | null | undefined): string {
  if (!value || !value.includes('-')) return '';
  const parts = value.split('-');
  if (parts.length < 3) return '';
  const [yyyy, mm, dd] = parts;
  return `${mm}/${dd.substring(0, 2)}/${yyyy}`;
}
